import React from "react";

export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-emerald-50/70 via-white to-white border-b border-slate-100">
      <div className="blob bg-emerald-200/40 h-64 w-64 -top-16 -right-10" />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 py-14 md:py-20 text-center">
        {eyebrow && (
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1">
            {eyebrow}
          </span>
        )}
        <h1 className="section-title mt-4 text-4xl md:text-5xl font-extrabold text-slate-900">
          {title}
        </h1>
        {subtitle && <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}

export function LegalBody({ children }) {
  return (
    <section className="py-14 md:py-16 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 legal-body">
        {children}
      </div>
    </section>
  );
}
